<template>
  <div class="page-template category-page" v-loading="loading">
    <!--    <menu-list></menu-list>-->
    <div class="category-box">
      <div class="category-list">
        <div class="category-title">一级分类
          <span class="icon el-icon-circle-plus-outline" @click="addClass(1)" v-if="!this.$utils.getSysUser().storeId">添加</span>
        </div>
        <list-template v-loading="loading" ref="tableOptions1" @rowClick="level1Check" :tableOptions="tableOptions1"
                       :toolConfig="toolConfig" :tableData="categoryLevel1"></list-template>
      </div>
      <div class="category-list">
        <div class="category-title">二级分类
          <span class="icon el-icon-circle-plus-outline" @click="addClass(2)" v-if="!this.$utils.getSysUser().storeId">添加</span>
        </div>
        <list-template v-loading="loading" ref="tableOptions2" @rowClick="level2Check" :tableOptions="tableOptions2"
                       :toolConfig="toolConfig" :tableData="categoryLevel2"></list-template>
      </div>
      <div class="category-list">
        <div class="category-title">三级分类
          <span class="icon el-icon-circle-plus-outline" @click="addClass(3)" v-if="!this.$utils.getSysUser().storeId">添加</span>
        </div>
        <list-template v-loading="loading" ref="tableOptions3" :tableOptions="tableOptions3" :toolConfig="toolConfig"
                       :tableData="categoryLevel3"></list-template>
      </div>
    </div>

    <el-dialog :title="dialogTitle" width="700px" custom-class="category-dialog" :close-on-click-modal="false"
               :visible.sync="addDialogShow" @close="closeDialog">
      <div v-if="level1">
        <span class="form-label">类型</span>{{level1}}
        <span class="el-icon-arrow-right icon" v-show="level2"></span>{{level2}}
        <span class="el-icon-arrow-right icon" v-show="level3"></span>{{level3}}
      </div>
      <el-form ref="form" :rules="rules" :model="form" :show-message="false" style="padding-left: 100px">
        <el-col :span="24">
          <el-form-item label='类别编码' prop="code">
            <el-input v-model="form.code" placeholder='请输入类别编码' disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='类别名称' prop="name">
            <el-input v-model="form.name" :maxlength="16" placeholder='请输入类别名称'></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="foot">
            <el-button type='primary' @click="save">保存</el-button>
            <el-button type='default' @click="reset">重置</el-button>
          </div>
        </el-col>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import listTemplate from '@/components/template/listTemplate'
  import formTemplate from '@/components/template/formTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {formTemplate, listTemplate},
    data() {
      return {
        rules: {
          code: [{required: true, message: '请输入类别编码', trigger: 'blur'}],
          name: [{required: true, message: '请输入类别名称', trigger: 'blur'}]
        },
        addDialogShow: false,
        level1: '',
        level2: '',
        level3: '',
        dialogTitle: '',
        dialogVisible: false,
        loading: false,
        title: '',
        toolConfig: [
          {
            label: '编辑',
            code: 'update',
            callback: this.editCategory,
            filter: () => {
              return !this.$utils.getSysUser().storeId
            }
          },
          {
            label: '删除',
            code: 'delete1',
            callback: this.deleteCategory,
            filter: () => {
              return !this.$utils.getSysUser().storeId
            }
          }
        ],
        tableOptions1: {
          height: this.height,
          tableName: 'tableOptions1',
          indexShow: true,
          isRowClick: true,
          columns: [
            {label: '编码', prop: 'code', align: 'center'},
            {label: '类别名称', prop: 'name', align: 'center'}
          ]
        },
        tableOptions2: {
          height: this.height,
          tableName: 'tableOptions2',
          indexShow: true,
          isRowClick: true,
          columns: [
            {label: '编码', prop: 'code', align: 'center'},
            {label: '类别名称', prop: 'name', align: 'center'}
          ]
        },
        tableOptions3: {
          height: this.height,
          tableName: 'tableOptions3',
          indexShow: true,
          isRowClick: true,
          columns: [
            {label: '编码', prop: 'code', align: 'center'},
            {label: '类别名称', prop: 'name', align: 'center'}
          ]
        },
        categoryLevel1: [],
        categoryLevel2: [],
        categoryLevel3: [],
        form: {
          code: '',
          name: '',
          parentId: 0
        },
        level1Row: null,
        level2Row: null,
        operationType: '',
        parentId: 0,
        isReaptName: false,
        rowCode: ''
      }
    },
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 120 - 70
    },
    created() {
      this.title = document.title;
      this.getCategoryLevel(0, 1);
      // let refName
      // if(level === 1){
      //   refName = 'tableOptions1'
      // }
      // if(level === 2){
      //   refName = 'tableOptions2'
      // }
      // if(data.data.length>0 && this.$refs[refName]) this.$refs[refName].setCurrentRow(refName, data.data[0])
    },
    mounted() {
      // console.log(this['categoryLevel1'])
      // this.level1Check(this['categoryLevel1'][0],'tableOptions1')
    },
    methods: {
      // 生成验证码
      getCode() {
        this.$axios.fetchGet(api.archives.getCategoryCode + '?type=10&parentId=' + this.form.parentId, {}).then(result => {
          this.loading = false;
          if (result.code == 200) {
            this.form.code = result.data;
          } else {
            this.$message({type: 'error', message: result.msg});
          }
        })
          .catch(err => {
            this.$message({type: 'error', message: '获取失败!'});
          })
      },
      // 点击添加
      addClass(level) {
        this.operationType = 'add'
        switch (level) {
          case 1:
            this.dialogTitle = '添加一级分类'
            this.form.parentId = 0
            this.level1 = '';
            this.getCode()
            this.addDialogShow = true
            break;
          case 2:
            if (this.rowCode == 'JARVIS_SYSTEM') {
              this.$message.warning('系统默认分类不许添加子分类')
            } else if (!this.level1Row) {
              this.$message({message: '请选择一级分类', type: 'warning'});
            } else {
              this.level1 = this.level1Row.name;
              this.level2 = '二级分类';
              this.level3 = '';
              this.dialogTitle = '添加二级分类';
              this.form.parentId = this.level1Row.id
              this.getCode()
              this.addDialogShow = true
            }
            break;
          case 3:
            if (!this.level2Row || !this.level1Row) {
              this.$message({message: '请选择二级分类', type: 'warning'});
            } else {
              this.level1 = this.level1Row.name;
              this.level2 = this.level2Row.name;
              this.level3 = '三级分类';
              this.dialogTitle = '添加三级分类';
              this.form.parentId = this.level2Row.id
              this.getCode()
              this.addDialogShow = true
            }
            break;
        }
      },
      // 校验类别名称重复
      checkName(val) {
        return new Promise((resolve, reject) => {
          this.$axios.fetchGet(api.archives.categoryName + '?categoryName=' + val, {}).then(res => {
            this.loading = false;
            if (res.code == 200) {
              if (!res.data) {
                this.$message({type: 'warning', message: '名称重复'});
                this.form.name = ''
                this.isReaptName = false
              } else {
                this.isReaptName = true
              }
              resolve(this.isReaptName)
            } else {
              this.$message({type: 'error', message: res.msg});
            }
          })
            .catch(err => {
              this.$message({type: 'error', message: '获取失败!'});
            })
        })
      },
      // 提交
      save() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.checkName(this.form.name).then(data => {
              if (data) {
                this.$loading({text: '提交中，请稍后。。。'})
                this.$axios[this.operationType == 'add' ? 'fetchPost' : 'fetchPut']
                (api.archives.categoryList, this.form).then(data => {
                  if (data.code == 200) {
                    this.$notify({
                      type: "success",
                      title: (this.operationType == 'add' ? '添加' : '编辑') + '操作',
                      message: '成功',
                      showClose: false,
                    });
                    // this.$message({type: 'success', message: (this.operationType == 'add' ? '添加' : '编辑') + '成功!'});
                    this.closeDialog()
                    this.level2Row = null
                    this.level1Row = null
                    this.getCategoryLevel(0, 1);
                  } else {
                    this.$message({message: data.msg, type: 'error'});
                  }
                }).catch((err) => {
                  this.$message({message: (this.operationType == 'add' ? '添加' : '编辑') + '出错', type: 'error'});
                }).finally(() => {
                  this.$loading({}).close()
                })
              }
            })
          } else {
            return false
          }
        })
      },
      closeDialog() {
        this.addDialogShow = false
        this.form = {
          code: '',
          name: ''
        }
        this.$refs.form.resetFields()
      },
      reset() {
        this.form.name = ''
      },
      // 点击 一级分类列表 行
      level1Check(row, refName) {
        this.$refs[refName].setCurrentRow(refName)
        this.$refs[refName].setCurrentRow(refName, row)
        this.rowCode = row.code
        this.level2Row = null;
        this.getCategoryLevel(row.id, 2);
        this.level1Row = row;
      },
      // 点击 二级分类列表 行
      level2Check(row, refName) {
        // this.$refs[refName].setCurrentRow(refName)
        // this.$refs[refName].setCurrentRow(refName, row)
        this.getCategoryLevel(row.id, 3);
        this.level2Row = row;
      },
      editCategory(row) {
        this.level1 = '';
        this.addDialogShow = true;
        this.dialogTitle = '编辑分类';
        this.operationType = 'edit';
        this.$axios.fetchGet(api.archives.categoryList + '?id=' + row.id, {}).then(res => {
          this.form = res.data
          this.isReaptName = true
        }).catch(() => {
        })
      },
      deleteCategory(row) {
        this.$confirm('确认删除数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$axios
              .fetchDelete(api.archives.categoryList, {
                id: row.id
              })
              .then(data => {
                if (data.code === 200) {
                  this.level2Row = null
                  this.level1Row = null
                  this.$notify({
                    type: "success",
                    title: '删除操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message({type: 'success', message: '删除成功!'});
                  this.getCategoryLevel(0, 1);
                } else {
                  if (data.code === 11010141 || data.code === 11010130) {
                    this.$message({message: data.errorMsg, type: 'warning'});
                  } else {
                    this.$message({message: data.errorMsg, type: 'error'});
                  }
                }
              });
          });
      },
      // 分类列表数据
      getCategoryLevel(parentId, level) {
        this.loading = true;
        this.$axios.fetchPost(api.archives.categoryList + '/list', {parentId: parentId}).then(data => {
          if (data.code === 200) {
            this['categoryLevel' + level] = data.data;
            if (level != 3 && data.data && data.data.length > 0) {
              this.getCategoryLevel(data.data[0].id, level + 1);
            } else if (data.data && data.data.length == 0) {
              this['categoryLevel3'] = []// 选择一级时，三级不置空问题
            }
            let refName
            if (level === 1) {
              refName = 'tableOptions1'
              this.level1Row = this['categoryLevel1'][0]
            }
            if (level === 2) {
              refName = 'tableOptions2'
              this.level2Row = this['categoryLevel2'][0]
            }
            if (data.data.length > 0 && this.$refs[refName]) this.$refs[refName].setCurrentRow(refName, data.data[0])
          } else {
            this.$message({message: data.msg, type: 'error'});
          }
        })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
</script>
<style>
  .category-page .category-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    /*padding:20px;*/
  }

  .category-page .category-box .category-list {
    /*margin-right: 15px;*/
    min-height: 100%;
    width: 32%;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: -3px -3px 5px rgba(69, 70, 72, 0.1), 3px 3px 5px rgba(69, 70, 72, 0.1);
  }

  .category-page .category-box .category-title {
    height: 50px;
    padding: 0 20px;
    line-height: 50px;
    font-size: 17px;
    font-weight: bolder;
  }

  .category-page .category-box .category-title .icon {
    float: right;
    line-height: 50px;
    color: #5e57e3;
    font-size: 15px;
  }

  .category-page .category-box .list-template {
    border-radius: 5px 5px 0 0;
  }

  .category-page .category-box .list-template .el-table {
    border-radius: 0 0 5px 5px;
  }

  .category-page .form-label {
    width: 150px;
    text-align: right;
    padding-right: 9px;
    display: inline-block;
    line-height: 30px;
  }

  .category-dialog.el-dialog {
    min-width: unset;;
  }

  .category-page .el-icon-arrow-right.icon {
    margin: 0 10px;
  }

  .category-page .foot {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Category.vue